import { render, staticRenderFns } from "./static_loss_compositions.vue?vue&type=template&id=01fad446"
import script from "./static_loss_compositions.vue?vue&type=script&lang=js"
export * from "./static_loss_compositions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports